import { filterProps } from "./auth-service-tools173.js";
import "react";
import "./auth-service-tools177.js";
import { useMantineTheme } from "./auth-service-tools196.js";

function useProps(component, defaultProps, props) {
  var _a;

  const theme = useMantineTheme();
  const contextPropsPayload = (_a = theme.components[component]) == null ? void 0 : _a.defaultProps;
  const contextProps = typeof contextPropsPayload === "function" ? contextPropsPayload(theme) : contextPropsPayload;
  return { ...defaultProps,
    ...contextProps,
    ...filterProps(props)
  };
}

export { useProps };